import styled from 'styled-components';

export const Title = styled.h1`
  text-align: center;
`;
